import client from "./client";
import EndUrls from "./endUrls";
import { getService, patchService, postService } from "./services";

export const handleLoginApiCall = async (data) => await client.post(EndUrls.login, data);

export const handleAdduserApiCall = async (data) =>
   await postService(EndUrls.addUser, data, true);

export const handleListuserApiCall = async (data) =>
   await getService(EndUrls.listUser, true);
// await client.get(EndUrls.listUser, config);

export const handleGetParentRoleApiCall = async (data) =>
   await getService(EndUrls.parentRole, true);

// Add Location Master
export const handleAddLocationMaster = async (data) =>
   await postService(EndUrls.addLocationMaster, data, true);

export const handleLocationMasterList = async () =>
   await getService(EndUrls.locationMasterList, true);

export const handleLocationMasterSingleList = async (id, model_id, action_id) =>
   await getService(EndUrls.locationMasterSingleList(id, model_id, action_id), true);

export const handleLocationMasterUpdate = async (data) =>
   await patchService(EndUrls.locationMasterUpdate, data, true);

// export const handleGetParentRoleApiCall= async (data)=> await client.get(EndUrls.parentRole, {headers:{Authorization : `Bearer ${JSON.parse(localStorage.getItem('token'))}`}})

export const handleEdituserApiCall = async (data) =>
   await patchService(EndUrls.editUser, data, true);

// fleet master
export const getDropdownDataApiCall = async () =>
   await getService(EndUrls.getDropdownData, true);

export const addFleetApiCall = async (data) =>
   await postService(EndUrls.addFleet, data, true);

export const addVehicleAndEmiDetailsApiCall = async (data) =>
   await postService(EndUrls.addVehicleAndEmiDetails, data, true);

export const listFleetApiCall = async () => await getService(EndUrls.listFleet, true);

export const updateFleetApiCall = async (data) =>
   await postService(EndUrls.updateFleet, data, true);

// driver master
export const fetchAllContractorsApiCall = async () =>
   await getService(EndUrls.fetchAllContractors, true);

export const addDriverMasterApiCall = async (data) =>
   await postService(EndUrls.addDriverMaster, data, true);

export const listDriverMasterApiCall = async () =>
   await getService(EndUrls.listDriverMaster, true);

export const updateDriverMasterApiCall = async (data) =>
   await postService(EndUrls.updateDriverMaster, data, true);

export const getDriverDropdownDataApiCall = async () =>
   await getService(EndUrls.getDriverDropdownData, true);

export const getCustomerDropdownDataApiCall = async () =>
   await getService(EndUrls.getCustomerDropdownData, true);

// customer master
// export const fetchAllCustomersApiCall = async () =>
//   await client.get(EndUrls.fetchAllCustomers, config);

export const addCustomerMasterApiCall = async (data) =>
   await postService(EndUrls.addCustomerMaster, data, true);

export const listCustomerMasterApiCall = async () =>
   await getService(EndUrls.listCustomerMaster, true);

export const updateCustomerMasterApiCall = async (data) =>
   await postService(EndUrls.updateCustomerMaster, data, true);

// export const handleContractorMasterApiCall = async (data) =>
//   await client.post(EndUrls.contractorAdd, data, {
//     headers: {
//       Authorization: `Bearer ${JSON.parse(localStorage.getItem("token"))}`,
//     },
//   });

// Lane Master

export const addLaneMasterApiCall = async (data) =>
   await postService(EndUrls.addLaneMaster, data, true);

//Helper master
// Add Helper-master
export const addHelperMasterApiCall = async (data) =>
   await postService(EndUrls.addHelperMaster, data, true);

export const getAllVendorsApiCall = async () =>
   await getService(EndUrls.getAllVendors, true);

export const listLaneMasterApiCall = async () =>
   await getService(EndUrls.listLaneMaster, true);

// export const updateLaneMasterApiCall = async (data) =>
//   await client.post(EndUrls.updateLaneMaster, data, config);
// Get Helper-master
export const listHelperMasterApiCall = async () =>
   await getService(EndUrls.listHelperMaster, true);

// Get single Helper-master
export const fetchSingleHelperMasterApiCall = async (id) =>
   await getService(`/helper/fetch/${id}?&model_id=5&action_id=3`, true);

// Update Helper Master
export const updateHelperMasterApiCall = async (data) =>
   await postService(EndUrls.updateHelperMaster, data, true);

// Get all lane
export const getAllLaneApiCall = async () => {
   return await getService(EndUrls.listLane, true);
};
export const updateLaneApiCall = async (data) => {
   return await postService(EndUrls.updateLane, data, true);
};
// Vendor Master
//add vendor
export const addVendorMasterApiCall = async (data) =>
   await postService(EndUrls.addVendorMaster, data, true);

// Vendor list
export const listVendorMasterApiCall = async () =>
   await getService(EndUrls.listVendorMaster, true);

// Contact person details
export const contactPersonDetailsApiCall = async (id) =>
   await getService(
      `/vendor/fetch/child/${id}?&table_name=contact_person_details&model_id=7&action_id=3`,
      true
   );

// Get single vendorMaster
export const singleVendorMasterApiCall = async (id) =>
   await getService(`/vendor/fetch/${id}?&model_id=7&action_id=3`, true);

export const updateContactApi = async (data) =>
   await postService("/vendor/update/child", data, true);

// Lanne master details
export const laneMasterDetailsApiCall = async (id) =>
   await getService(
      `/vendor/fetch/child/${id}?&table_name=lane_masters&model_id=7&action_id=3`,
      true
   );

// Update contact
export const updateVendorChildApi = async (data) =>
   await postService("/vendor/update/child", data, true);

// Add contact for vendor
export const addVendorChildApi = async (data) =>
   await postService("/vendor/add/child", data, true);

// update vendor
export const updateVendorApi = async (data) =>
   await postService("/vendor/update", data, true);

// contractor master
export const handleContractorMasterApiCall = async (data) =>
   await postService(EndUrls.contractorAdd, data, true);

export const handleContractorMasterListApiCall = async () =>
   await getService(EndUrls.contractorList, true);

export const handleContractorMasterEditApiCall = async (data) =>
   await postService(EndUrls.contractorUpdate, data, true);

export const handleContractorcontactsdetailsApiCall = async (id) =>
   await getService(EndUrls.singleConractorContactDetails(id), true);

export const handlesingleContractorcontactsdetailsAddApiCall = async (data) =>
   await postService(EndUrls.singleConractorContactAdd, data, true);

export const handlesingleContractorcontactsdetailsEditApiCall = async (data) =>
   await postService(EndUrls.singleConractorContactEdit, data, true);

//Trip
// Get all trip api
export const listTripApiCall = async (
   role = "corporateAdmin",
   id,
   limit,
   offset,
   trip_status,
   review_status
) => {
   let url =
      role === "corporateAdmin"
         ? EndUrls.listTrip
         : role === "manager"
         ? EndUrls.managerTripList(id)
         : EndUrls.listTrip;

   // Append query parameters
   const params = new URLSearchParams();
   if (limit) params.append("limit", limit);
   if (offset) params.append("offset", offset);
   if (trip_status) params.append("trip_status", trip_status);
   if (review_status) params.append("review_status", review_status);

   url += `&${params.toString()}`;

   return await getService(url, true);
};

export const listTripByPaginationApiCall = async (
   role = "corporateAdmin",
   id,
   limit,
   page,
   trip_status,
   review_status,
   search
) => {
   let url = EndUrls.listTripByPagination;

   // Append query parameters
   const params = new URLSearchParams();
   if (limit) params.append("limit", limit);
   if (page) params.append("page", page);
   if (trip_status) params.append("trip_status", trip_status);
   if (review_status) params.append("review_status", review_status);
   if (search) params.append("search", search);

   url += `&${params.toString()}`;

   return await getService(url, true);
};

// Get single trip api
export const singleTripApiCall = async (id) =>
   await getService(EndUrls.singleTrip(id), true);

// Update trip manager api
export const updateTripManagerApiCall = async (data) =>
   await postService(EndUrls.updateTripManager, data, true);

// Update trip manager api
export const updateTripDetailsApiCall = async (data) =>
   await postService(EndUrls.updateTripDetails, data, true);

// Update trip review status
export const updateTripReviewStatusApiCall = async (data) =>
   await postService(EndUrls.updateTripReviewStatus, data, true);

// Update adhoc trip review status
export const updateAdhocTripReviewStatusApiCall = async (data) =>
   await postService(EndUrls.updateAdhocTripReviewStatus, data, true);

export const addAdhocLaneApiCall = async (data) =>
   await postService(EndUrls.addhocLaneAdd, data, true);

// Edit adhoc lane
export const editAdhocLaneApiCall = async (data) =>
   await postService(EndUrls.adhocLaneEdit, data, true);

export const getAdhocLaneListApiCall = async () =>
   await getService(EndUrls.getAdhocLaneList(2, 3), true);

export const getAdhocLaneApiCall = async (laneId) =>
   await getService(EndUrls.getAdhocLane(laneId, 2, 3), true);

// Update lane review status
export const updateAdhocLaneReviewStautsApiCall = async (data) =>
   await postService(EndUrls.updateAdhocLaneReviewStauts, data, true);

// Get all Adhoc trip list
export const getAdhocTripApiCall = async (role) =>
   await getService(EndUrls.adhocTripList, true);

// Get all Adhoc trip list by pagination
export const getAdhocTripByPaginationApiCall = async (
   limit,
   page,
   trip_status,
   review_status,
   search
) => {
   let url = EndUrls.adhocTripListByPagination;

   // Append query parameters
   const params = new URLSearchParams();
   if (limit) params.append("limit", limit);
   if (page) params.append("page", page);
   if (trip_status) params.append("trip_status", trip_status);
   if (review_status) params.append("review_status", review_status);
   if (search) params.append("search", search);

   url += `&${params.toString()}`;

   return await getService(url, true);
};
// Get single adhoc trip
export const getSingleAdhocTripApiCall = async (id) =>
   await getService(EndUrls.getSingleAdhocTrip(id), true);

// Update adhoc trip manager
export const updateAdhocTripManagerApiCall = async (data) =>
   await postService(EndUrls.adhocTripUpdateManager, data, true);

export const createActualApiCall = async (data) =>
   await postService(EndUrls.createActual, data, true);

export const createActualAdhocApiCall = async (data) =>
   await postService(EndUrls.createActualAdhoc, data, true);

// Contractor master single
export const getSingleContractorMasterApiCall = async (id) =>
   await getService(EndUrls.singleContractorMaster(id), true);

// reports
export const fleetReportApiCall = async (data) =>
   await postService(EndUrls.fleetReport, data, true);

// Fleet Maintainance Report
export const fleetMaintainanceReportApiCall = async (data) =>
   await postService(EndUrls.fleetMaintainanceReport, data, true);

// Customer Master Report
export const customerMasterReportApiCall = async (data) =>
   await postService(EndUrls.customerMasterReport, data, true);

// Vendor Master Report
export const vendorMasterReportApiCall = async (data) =>
   await postService(EndUrls.vendorMasterReport, data, true);

// Driver Master Report
export const driverMasterReportApiCall = async (data) =>
   await postService(EndUrls.driverMasterReport, data, true);

export const driverSalaryReportApiCall = async (data) =>
   await postService(EndUrls.driverSalaryReport, data, true);

// Helper Master Report
export const helperMasterReportApiCall = async (data) =>
   await postService(EndUrls.helperMasterReport, data, true);

// Contractor Master Report
export const contractorMasterReportApiCall = async (data) =>
   await postService(EndUrls.contractorMasterReport, data, true);

// Lane Master Report
export const laneMasterReportApiCall = async (data) =>
   await postService(EndUrls.laneMasterReport, data, true);

// Trip Master Report
export const tripMasterReportApiCall = async (data, params) => {
   const queryString = new URLSearchParams(params).toString(); // Convert params object to a query string
   const url = `${EndUrls.tripMasterReport}?${queryString}`; // Append params to URL

   return await postService(url, data, true);
};

// Trip Master Dashboard Report
export const tripDashboardReportApiCall = async () => {
   return await getService(EndUrls.tripDashboardReport, true);
};
